import { RouteComponentProps } from '@reach/router';

import useGetInvoiceInventoryQuery from 'api/invoicing/useGetInvoiceInventoryQuery';
import ApiError from 'components/shared/ApiError';
import LoadingIndicator from 'components/shared/LoadingIndicator';

import VehicleList from '../../VehicleList/VehicleList';
import Header from './Header';

import './InvoiceList.scss';

type Props = RouteComponentProps;

const InvoiceList = ({ navigate, ...props }: Props) => {
  const getInvoiceInventoryQuery = useGetInvoiceInventoryQuery();
  const handleListClick = () => {};
  const vehicles = getInvoiceInventoryQuery.data?.data ?? [];
  const noVehicles = (
    <span className="vendor-no-vehicles full-height full-width flex-rows">
      No vehicles found!
    </span>
  );

  if (getInvoiceInventoryQuery.isSuccess && vehicles.length === 0) {
    return noVehicles;
  }

  return (
    <div className="vendor-invoice-list">
      <main className="vendor-invoice-list-content">
        {getInvoiceInventoryQuery.isLoading ? (
          <LoadingIndicator />
        ) : (
          <div className="vendor-invoice-list-container">
            <Header />
            <VehicleList vehicles={vehicles} onClick={handleListClick} />
            {getInvoiceInventoryQuery.error && (
              <ApiError error={getInvoiceInventoryQuery.error} />
            )}
          </div>
        )}
      </main>
    </div>
  );
};

export default InvoiceList;
